import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import {
	getProductsByCollection,
	selectProducts,
} from "store/vino/productsSlice";
import { ProductList } from "vino/components/ProductList";

const ProductsList = () => {
	const dispatch = useDispatch();
	const products = useSelector(selectProducts);

	const selectedCollectionId = useSelector(
		({ vino }) => vino.productCollections.selectedCollectionId
	);

	useEffect(() => {
		dispatch(getProductsByCollection(selectedCollectionId));
	}, [selectedCollectionId, dispatch]);

	return <ProductList products={products} />;
};

export default ProductsList;
